function setSearchClearBtnState(){
    const searchField = $('.js-main-search');
    const clearBtn = $('.js-btn-search-clear');

    searchField.val() == '' 
    ? clearBtn.removeClass('active').closest('.js-form-item-wrap-search').removeClass('filled')
    : clearBtn.addClass('active').closest('.js-form-item-wrap-search').addClass('filled');
}

runIfElementExist(setSearchClearBtnState, '.js-btn-search-clear');

$(document).on('input', '.js-main-search', function(){
    setSearchClearBtnState();
})

$(document).on('click', '.js-btn-search-clear', function(){
    const target = $(this).data('target');
    $(`#${target}`).val('').trigger('input');
    $(this).removeClass('active');
    $(this).closest('.js-form-item-wrap-search').removeClass('filled');
});
